// WebView için dil yönetimi utility fonksiyonları

/**
 * URL parametrelerinden dil bilgisini alır
 * @returns {string|null} Dil kodu (tr, en, de) veya null
 */
export const getLanguageFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  return ['tr', 'en', 'de'].includes(lang) ? lang : null;
};

/**
 * WebView modunda olup olmadığını kontrol eder
 * @returns {boolean} WebView modunda ise true
 */
export const isWebViewMode = () => {
  return window.location.search.includes('webview=true');
};

/**
 * Dil değiştirici gösterilip gösterilmeyeceğini belirler
 * @returns {boolean} Dil değiştirici gösterilmeli ise true
 */
export const shouldShowLanguageSwitcher = () => {
  return !isWebViewMode();
};

/**
 * Varsayılan dili belirler (WebView için)
 * @returns {string} Varsayılan dil kodu
 */
export const getDefaultLanguage = () => {
  // URL'den dil parametresi varsa onu kullan
  const urlLang = getLanguageFromURL();
  if (urlLang) return urlLang;
  
  // localStorage'dan kaydedilmiş dil tercihini kontrol et
  const savedLang = localStorage.getItem('i18nextLng');
  if (savedLang && ['tr', 'en', 'de'].includes(savedLang)) {
    return savedLang;
  }
  
  // Tarayıcı dilini kontrol et
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('tr')) return 'tr';
  if (browserLang.startsWith('de')) return 'de';
  if (browserLang.startsWith('en')) return 'en';
  
  // Varsayılan olarak Türkçe
  return 'tr';
};

/**
 * WebView için dil ayarlarını uygular
 * @param {Function} changeLanguage - i18n.changeLanguage fonksiyonu
 */
export const applyWebViewLanguage = (changeLanguage) => {
  // Sadece URL'de dil parametresi varsa değiştir
  const urlLang = getLanguageFromURL();
  if (urlLang) {
    changeLanguage(urlLang);
  }
  // URL'de dil parametresi yoksa localStorage'daki tercihi koru
}; 